import {Component, React, observer, resolveCss} from '$src/handy'
import * as css from './Tab.css'
import {ResearchStateTab, ResearchStateTabs} from '$src/bootstrap/Store'
import {Link, withRouter, RouteComponentProps} from 'react-router-dom'
import GenericModal from '$src/common/GenericModal'
import GenericButton from '$src/common/GenericButton'
import onClickOutside from 'react-onclickoutside'
import CaretDownIcon from 'react-icons/lib/fa/caret-down'
import {Overlay} from 'react-overlays'
import {findDOMNode} from 'react-dom'

interface Props extends RouteComponentProps<any> {
  css?: any
  tabStoreState: typeof ResearchStateTab.Type
  isActive: boolean
  housingCorporationId: string
  tabsStoreState: typeof ResearchStateTabs.Type
  projectId: string
  projectName: string
  frozen: boolean
}

interface State {
  editingName: boolean
  menuOpen: boolean
}

// @ts-ignore
@withRouter
@observer
export default class Tab extends Component<Props, State> {
  containerRef: any
  inputRef: any

  constructor(props: Props, context: any) {
    super(props, context)
    this.state = {editingName: false, menuOpen: false}
    this.inputRef = null
  }

  onClick = (e: any) => {
    if (this.props.isActive) {
      this.setState({editingName: true})
      e.preventDefault()
    } else {
    }
  }

  UNSAFE_componentWillReceiveProps(newProps: Props) {
    if (newProps.isActive !== true) {
      this.setState({editingName: false, menuOpen: false})
    }
  }

  onChange = (e: any) => {
    if (this.props.frozen) return
    this.props.tabStoreState.setName(e.target.value)
  }

  setInputRef = (ref: any) => {
    this.inputRef = ref

    this.fitInput()
  }

  fitInput = () => {
    const min = 100
    const max = 300
    const pad_right = 5
    const input = this.inputRef
    if (!input) return

    input.style.width = min + 'px'

    // setTimeout(function() {
    const tmp = document.createElement('div')
    tmp.style.padding = '0'
    if (getComputedStyle)
      tmp.style.cssText = getComputedStyle(input, null).cssText
    if (input.currentStyle) tmp.style.cssText = input.currentStyle.cssText
    tmp.style.width = ''
    tmp.style.position = 'absolute'
    tmp.style.left = '-55555px'
    tmp.innerHTML = input.value
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;')
      .replace(/ /g, '&nbsp;')
    input.parentNode.appendChild(tmp)
    const width = tmp.clientWidth + pad_right + 1
    // @ts-ignore
    tmp.parentNode.removeChild(tmp)
    if (min <= width && width <= max) input.style.width = width + 4 + 'px'
    // }, 0)
  }

  onInputBlur = () => {
    this.setState({editingName: false})
  }

  onInputKeyUp = e => {
    if (e.keyCode === 13) {
      this.inputRef.blur()
    }

    this.fitInput()
  }

  setContainerRef = (ref: React.Ref<HTMLElement>) => {
    this.containerRef = ref
  }

  render() {
    const {props, state} = this
    const classes = resolveCss(css, props.css)

    return (
      <Link
        {...classes(
          'container',
          props.isActive && 'active',
          state.editingName && 'editingName',
          props.tabStoreState.enabled === false && 'disabled',
          props.frozen && 'frozen',
        )}
        to={`/comparable-sales-list/${props.projectId}/${props.projectName}/${props.housingCorporationId}/${props.tabStoreState.id}`}
        onClick={this.onClick}
        ref={this.setContainerRef}
      >
        <input
          type="text"
          {...classes('name')}
          value={props.tabStoreState.name}
          onChange={this.onChange}
          disabled={props.frozen || !props.isActive}
          ref={this.setInputRef}
          onKeyDown={this.fitInput}
          onKeyUp={this.onInputKeyUp}
          onKeyPress={this.fitInput}
          onBlur={this.onInputBlur}
        />
        {!props.frozen && (
          <div className={css.menuTrigger} onClick={this.onTriggerClick}>
            <CaretDownIcon />
          </div>
        )}
        {state.menuOpen && (
          <Overlay
            show={true}
            onHide={this.closeMenu}
            placement="bottom"
            container={document.body}
            target={() => findDOMNode(this.containerRef)}
          >
            <Menu
              // @ts-ignore
              onClose={this.closeMenu}
              onDelete={this.delete}
              onSetEnabledStatus={this.setEnabledStatus}
              enabled={props.tabStoreState.enabled}
              deletable={props.tabsStoreState.list.length > 1}
            />
          </Overlay>
        )}
      </Link>
    )
  }

  onTriggerClick = () => {
    this.setState({menuOpen: true})
  }

  closeMenu = () => {
    this.setState({menuOpen: false})
  }

  delete = () => {
    const otherTab = this.props.tabsStoreState.list.find(
      s => s.id !== this.props.tabStoreState.id,
    )

    this.props.history.push(
      `/comparable-sales-list/${this.props.projectId}/${this.props.projectName}/${this.props.housingCorporationId}/${otherTab.id}`,
    )

    setTimeout(() => {
      this.props.tabsStoreState.delete(this.props.tabStoreState.id)
    }, 200)
  }

  setEnabledStatus = (enabled: boolean) => {
    this.props.tabStoreState.setEnabledStatus(enabled)
  }
}

// @ts-ignore
@onClickOutside
class Menu extends Component<
  {
    onClose: Function
    onDelete: Function
    onSetEnabledStatus: (s: boolean) => void
    deletable: boolean
    enabled: boolean
    style?: {
      top: string
      left: string
    }
  },
  {areYouSurePromptShowing: boolean}
> {
  modalRef: null | any
  constructor(props: any, context: any) {
    super(props, context)
    this.state = {areYouSurePromptShowing: false}
    this.modalRef = null
  }

  handleClickOutside(e) {
    let el = e.target
    while (el) {
      if (el === this.modalRef) return
      el = el.parentNode
    }

    this.props.onClose()
  }

  setModalRef = (ref: any) => {
    this.modalRef = ref
  }

  render() {
    const {props} = this

    const classes = resolveCss(css)

    return (
      <div
        {...classes('menuContainer')}
        style={{left: props.style.left + 'px', top: props.style.top + 'px'}}
      >
        <div {...classes('item')} onClick={this.toggleEnabled}>
          {props.enabled ? 'Disable' : 'Enable'}
        </div>
        {props.deletable && (
          <div {...classes('item')} onClick={this.showAreYouSurePrompt}>
            Delete
          </div>
        )}
        {this.state.areYouSurePromptShowing && (
          <GenericModal
            show={true}
            onHide={this.hideAreYouSurePrompt}
            withPadding={true}
            css={{box: {container: css.areYouSureBox}}}
            setContainerRef={this.setModalRef}
          >
            <p className={css.warningMessage}>Are you sure?</p>
            <GenericButton
              variant="pale"
              type="submit"
              onClick={props.onClose}
              withMargin={true}
            >
              Never mind
            </GenericButton>
            <GenericButton
              variant="bold"
              type="submit"
              onClick={props.onDelete}
              withMargin={true}
            >
              Delete Tab
            </GenericButton>
          </GenericModal>
        )}
      </div>
    )
  }

  showAreYouSurePrompt = () => {
    this.setState({areYouSurePromptShowing: true})
  }

  hideAreYouSurePrompt = () => {
    this.setState({areYouSurePromptShowing: false})
  }

  toggleEnabled = () => {
    this.props.onSetEnabledStatus(!this.props.enabled)
  }
}



// WEBPACK FOOTER //
// ./src/comparableSales/Tab.tsx